import { combineReducers } from 'redux';

import aiAgents from './aiAgents.reducer';
import aiChatConfigurations from './aiChatConfigurations.reducer';
import aiModelAssignments from './aiModelAssignments.reducer';
import aiModels from './aiModels.reducer';
import aiModelsByRole from './aiModelsByRole.reducer';
import aiPersonas from './aiPersonas.reducer';
import aiProcesses from './aiProcesses.reducer';
import aiSkills from './aiSkills.reducer';
import aiUsage from './aiUsage.reducer';
import appKeys from './appKeys.reducer';
import appraisalFeePricing from './appraisalFeePricing.reducer';
import appraisalProductCriteria from './appraisalProductCriteria.reducer';
import appraisalProducts from './appraisalProducts.reducer';
import appraisalProductSchema from './appraisalProductSchema.reducer';
import appraisalSurchargeCriteria from './appraisalSurchargeCriteria.reducer';
import appraisalSurcharges from './appraisalSurcharges.reducer';
import appraisalSurchargeSchema from './appraisalSurchargeSchema.reducer';
import autoLockRules from './autoLockRules.reducer';
import autoLockRulesSchema from './autoLockRulesSchema.reducer';
import automatedActionCriteria from './automatedActionCriteria.reducer';
import automatedActionCriteriaSchema from './automatedActionCriteriaSchema.reducer';
import bankrateLeadProvider from './bankrateLeadProvider.reducer';
import borrowerVestingTypes from './borrowerVestingTypes.reducer';
import campaigns from './campaigns.reducer';
import chatAssignmentCriteriaSchema from './chatAssignmentCriteriaSchema.reducer';
import checklists from './checklists.reducer';
import checklistsHydration from './checklistsHydration.reducer';
import checklistsSchema from './checklistsSchema.reducer';
import checklistsTargetType from './checklistsTarget.reducer';
import cicFeeReasons from './cicFeeReasons.reducer';
import cicFeeReasonSchema from './cicFeeReasonSchema.reducer';
import cicLoanTermReasons from './cicLoanTermReasons.reducer';
import closingPortal from './closingPortal.reducer';
import companyClaimRestrictions from './companyClaimRestrictions.reducer';
import companyDefaultHeaderViews from './companyDefaultHeaderViews.reducer';
import companyRoleRestrictions from './companyRoleRestrictions.reducer';
import completenessChecklistOptions from './completenessChecklistOptions.reducer';
import crm from './crm.reducer';
import customFieldDefinitions from './customFieldDefinitions.reducer';
import customFieldsExpressionSchema from './customFieldsExpressionSchema.reducer';
import denialReasons from './denialReasons.reducer';
import devTools from './devTools.reducer';
import documentBundles from './documentBundles.reducer';
import documentCalculationFields from './documentCalculationFields.reducer';
import documentCalculationFieldsRuleSchema from './documentCalculationFieldsRuleSchema.reducer';
import documentCategories from './documentCategories.reducer';
import documentExtractionFields from './documentExtractionFields.reducer';
import documentExtractionMapping from './documentExtractionMapping.reducer';
import documentFieldTypes from './documentFieldTypes.reducer';
import documentTypeAliases from './documentTypeAliases.reducer';
import documentTypes from './documentTypes.reducer';
import emailTemplateCategories from './emailTemplateCategories.reducer';
import emailTemplateProcessing from './emailTemplateProcessing.reducer';
import emailTemplates from './emailTemplates.reducer';
import emailTemplatesControlUI from './emailTemplatesControlUI.reducer';
import exceptionSubCategories from './exceptionSubCategories.reducer';
import externalProgramMappings from './externalProgramMappings.reducer';
import feeProvider from './feeProvider.reducer';
import feeProviderCategory from './feeProviderCategory.reducer';
import feeTypeMismo from './feeTypeMismo.reducer';
import feeTypes from './feeTypes.reducer';
import feeTypesSchema from './feeTypesSchema.reducer';
import guidelines from './guidelines.reducer';
import halcyonFormInclusionSchema from './halcyonFormInclusionSchema.reducer';
import headerViews from './headerViews.reducer';
import homeVisionJobTypeSettings from './homeVisionJobTypeSettings.reducer';
import impoundTypes from './impoundTypes.reducer';
import integrationStudio from './integrationStudio.reducer';
import investorFeatureCodes from './investorFeatureCodes.reducer';
import knowledgeItems from './knowledgeItems.reducer';
import lendersMappings from './lendersMappings.reducer';
import loanActionArithmeticOperationsSchema from './loanActionArithmeticOperationsSchema.reducer';
import loanActions from './loanActions.reducer';
import loanActionsConditions from './loanActionsConditions.reducer';
import loanActionEditor from './loanActionsEditor.reducer';
import loanActionsTargetType from './loanActionsTarget.reducer';
import loanEditorCustomForms from './loanEditorCustomForms.reducer';
import loanRoleAssignmentCriteriaSchema from './loanRoleAssignmentCriteriaSchema.reducer';
import loanRoleRelationships from './loanRoleRelationships.reducer';
import loanRoles from './loanRoles.reducer';
import loanRolesV2 from './loanRolesV2.reducer';
import lodeStarFeeTypes from './lodeStarFeeTypes.reducer';
import optimizationStrategies from './optimizationStrategies.reducer';
import pipelinesData from './pipelines.reducer';
import pipelinesSchema from './pipelinesSchema.reducer';
import postClosingOptions from './postClosingOptions.reducer';
import pricingConfiguration from './pricingConfiguration.reducer';
import programIdentifiers from './programIdentifiers.reducer';
import resolvedSubCompanyHeaderView from './resolvedSubCompanyHeaderView.reducer';
import roleUsers from './role.users.reducer';
import sellerAdjustmentTypes from './sellerAdjustmentTypes.reducer';
import settings from './settings.reducer';
import shapeLeadProvider from './shapeLeadProvider.reducer';
import tags from './tags.reducer';
import taskCategories from './taskCategories.reducer';
import taskTypeDynamicField from './taskTypeDynamicField.reducer';
import taskTypes from './taskTypes.reducer';
import telephony from './telephony.reducer';
import timedSequenceSchema from './timedSequenceSchema.reducer';
import turnTimeDefinitions from './turnTimeDefinitions.reducer';
import uiProgramSettings from './uiProgramSettings.reducer';
import warehouseAllocations from './warehouseAllocations.reducer';

export const APPRAISAL_PRODUCT_CRITERIA_REDUCER = 'appraisalProductCriteria';

export const AUTOMATED_ACTION_CRITERIA_REDUCER = 'automatedActionCriteria';

export const LOAN_ACTIONS_CRITERIA_REDUCER = 'loanActions';

const reducer = combineReducers({
  appKeys,
  appraisalFeePricing,
  appraisalProductCriteria,
  appraisalProducts,
  appraisalProductSchema,
  appraisalSurchargeCriteria,
  appraisalSurchargeSchema,
  appraisalSurcharges,
  autoLockRules,
  autoLockRulesSchema,
  automatedActionCriteria,
  automatedActionCriteriaSchema,
  borrowerVestingTypes,
  campaigns,
  chatAssignmentCriteriaSchema,
  checklists,
  checklistsHydration,
  checklistsSchema,
  checklistsTargetType,
  completenessChecklistOptions,
  crm,
  cicFeeReasons,
  cicFeeReasonSchema,
  cicLoanTermReasons,
  closingPortal,
  companyClaimRestrictions,
  companyRoleRestrictions,
  customFieldDefinitions,
  customFieldsExpressionSchema,
  denialReasons,
  devTools,
  documentBundles,
  documentCalculationFields,
  documentCalculationFieldsRuleSchema,
  documentCategories,
  documentExtractionFields,
  documentExtractionMapping,
  documentFieldTypes,
  documentTypeAliases,
  documentTypes,
  emailTemplateCategories,
  emailTemplateProcessing,
  emailTemplates,
  emailTemplatesControlUI,
  exceptionSubCategories,
  feeProvider,
  feeProviderCategory,
  feeTypes,
  feeTypesSchema,
  halcyonFormInclusionSchema,
  companyDefaultHeaderViews,
  headerViews,
  homeVisionJobTypeSettings,
  impoundTypes,
  investorFeatureCodes,
  knowledgeItems,
  externalProgramMappings,
  lendersMappings,
  loanActionArithmeticOperationsSchema,
  loanActions,
  loanActionsTargetType,
  loanActionEditor,
  loanEditorCustomForms,
  loanRoleAssignmentCriteriaSchema,
  loanRoles,
  loanRolesV2,
  lodeStarFeeTypes,
  pipelinesData,
  pipelinesSchema,
  postClosingOptions,
  pricingConfiguration,
  programIdentifiers,
  resolvedSubCompanyHeaderView,
  roleUsers,
  sellerAdjustmentTypes,
  settings,
  tags,
  taskCategories,
  telephony,
  taskTypeDynamicField,
  taskTypes,
  turnTimeDefinitions,
  timedSequenceSchema,
  loanRoleRelationships,
  uiProgramSettings,
  feeTypeMismo,
  loanActionsConditions,
  aiAgents,
  aiChatConfigurations,
  aiPersonas,
  aiProcesses,
  aiSkills,
  guidelines,
  aiUsage,
  aiModels,
  aiModelsByRole,
  aiModelAssignments,
  optimizationStrategies,
  warehouseAllocations,
  integrationStudio,
  bankrateLeadProvider,
  shapeLeadProvider,
});

export default reducer;
